export const PAYMENT_DONE_PARAMETER = "payment_done"
export const INSTANT_WIDGET = "instant_widget"
